import React from "react";
import { Link } from "react-router-dom";
import logo from "../img/ELARITECH.jpg";

export default function NavbarLogo() {
  return (
    <Link to="/" className="navbar-brand p-0" aria-label="ELARITECH - Inicio">
      <img src={logo} alt="ELARITECH" className="navbar-logo" />
    </Link>
  );
}
